<template>
  <div class="text-center">
    <div class="w-full flex justify-between justify-around">
      <div class="flex justify-around justify-between h-full">
        <!--
        <span class="text-lg font-bold text-center text-orange-300 m-2">X</span>
        -->
        <value-or-variable-with-label label='X' v-model='value.x' type="number" :variables='variables'>
          <template #default="{}">
            <numberer v-model='value.x' @change="onInputX" />
          </template>
        </value-or-variable-with-label>
      </div>
      <div class="flex justify-around justify-between h-full">
        <value-or-variable-with-label label='Y' v-model='value.y' type="number" :variables='variables'>
          <template #default="{}">
            <numberer v-model='value.y' @change="onInputX" />
          </template>
        </value-or-variable-with-label>
      </div>
    </div>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import Numberer from '@ui/atoms/Numberer.vue';
import ValueOrVariableWithLabel from '@ui/molecules/ValueOrVariableWithLabel.vue';
export default {
  props:{
    value:{
      type:Object,
      required:true
    },
    variables:{
      type:Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
    onInput(nv, ov) {
      this.$emit("change", nv, ov);
    },
    onInputX(nv, ov) {
      const oldValue = cloneDeep(this.value);
      oldValue.x = ov;
      this.onInput(cloneDeep(this.value), oldValue);
    },
    onInputY(nv, ov) {
      const oldValue = cloneDeep(this.value);
      oldValue.y = ov;
      this.onInput(cloneDeep(this.value), oldValue);
    }
  },
  components:{
    Numberer,
    ValueOrVariableWithLabel
  }
}
</script>
